import { defineMessages } from 'react-intl-next';

export default defineMessages({
	hubLogo: {
		id: 'company-hub.hub-app-shell.navbar.hub.logo',
		defaultMessage: 'Hub logo',
		description: 'The logo of the Hub',
	},
	login: {
		id: 'company-hub.hub-app-shell.navbar.hub.log-in',
		defaultMessage: 'Log in',
		description: 'Log in button label',
	},
});
